import { Link } from 'react-router-dom';
import { articlePath } from '../constants/articles';

export default function ArticleList({ articles }) {
  return (
    <div className="card-grid">
      {articles.map((article) => (
        <Link key={article.slug} to={articlePath(article.slug)} className="post-card">
          <span className="post-card__cat">{article.categoryLabel}</span>
          <h3>{article.title}</h3>
          <p>{article.excerpt}</p>
          <span className="post-card__more">Read guide ›</span>
        </Link>
      ))}
    </div>
  );
}
